import { render, staticRenderFns } from "./PageGender.vue?vue&type=template&id=be515038"
import script from "./PageGender.vue?vue&type=script&lang=js"
export * from "./PageGender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports